import { CONTENT_GROUP_SETTINGS } from "../constants";

const initialState = {
    isOpen: false,
    content_group_id: null,
    workspace_id: null,
    stage_id: null, // used for card settings dropdown
    boundary: null, // { top, left, width, height }
    content_group_id: null, // used for card settings dropdown,
    can_destroy: false,
    can_clone: false
};

export function card_settings_dropdown(state = initialState, action) {
    switch (action.type) {
        case CONTENT_GROUP_SETTINGS.OPEN_CONTENT_GROUP_SETTINGS:
            const { content_group_id, workspace_id, boundary, stage_id } = action.payload;

            return { 
                        ...state, 
                        isOpen: true, 
                        content_group_id, 
                        workspace_id,
                        stage_id,
                        boundary,
                        can_destroy: action.payload.can_destroy || false,
                        can_clone: action.payload.can_clone || false
                    };
        case CONTENT_GROUP_SETTINGS.CLOSE_CONTENT_GROUP_SETTINGS:
            return initialState;
        default:
            return state;
    }
}